import React, { useState, useEffect } from 'react';
import { Image } from 'react-bootstrap';
import { useAuthenticatedImage } from '../hooks/useAuthenticatedImage';

const ProfileImage = ({ 
  user, 
  size = 'medium', 
  className = '', 
  width, 
  height, 
  roundedCircle = false,
  onClick,
  onError,
  onLoad,
  style,
  ...props 
}) => {
  const [imageError, setImageError] = useState(false);

  // Use authenticated image hook
  const { 
    imageSrc, 
    isLoading, 
    hasError 
  } = useAuthenticatedImage(
    user?.profile_image,
    size,
    {
      fallbackSrc: '/images/default-avatar.svg',
      enabled: !!user?.profile_image && !imageError,
      onLoad: () => {
        setImageError(false);
        if (onLoad) onLoad();
      },
      onError: (error) => {
        console.error('ProfileImage: Image failed to load for user:', user?.user_id, error);
        setImageError(true);
        if (onError) onError();
      }
    }
  );

  // Reset image error when user changes
  useEffect(() => {
    setImageError(false);
  }, [user?.user_id, user?.profile_image]);

  const handleError = () => {
    console.error('ProfileImage: Image failed to load for user:', user?.user_id);
    setImageError(true);
    if (onError) onError();
  };

  const handleLoad = () => {
    setImageError(false);
    if (onLoad) onLoad();
  };

  // Determine the final image source
  const finalImageSrc = hasError || imageError ? '/images/default-avatar.svg' : imageSrc;

  return (
    <Image
      src={finalImageSrc}
      className={`${className} ${isLoading ? 'opacity-75' : ''}`}
      width={width}
      height={height}
      roundedCircle={roundedCircle}
      onClick={onClick}
      onError={handleError}
      onLoad={handleLoad}
      id={`profile_image_${user?.user_id}`}
      alt={'Profile Image'}
      style={{
        transition: 'opacity 0.2s ease-in-out',
        ...style
      }}
      {...props}
    />
  );
};

export default ProfileImage;
